import { isEmpty } from 'lodash';
import { getSupportedWidgetTypes } from '../config/utils';

export const parseState = (state) => {
  const { widgets, order } = state;

  const widgetTypes = Object.values(getSupportedWidgetTypes());

  let orderedWidgets: any = [];

  if (!isEmpty(order)) {
    const widSet = new Set(Object.keys(widgets));
    // order widgets
    order.forEach((oid) => {
      if (oid in widgets) {
        orderedWidgets.push(widgets[oid]);
        widSet.delete(oid);
      } else {
        // widget was removed, skip the id in order
      }
    });

    // items not present in the order will be pushed at the end
    widSet.forEach((wid) => orderedWidgets.push(widgets[wid]));
  } else {
    orderedWidgets = Object.values(widgets);
  }

  // This is a redundant filtering as state is cleaned up on init itself
  // TODO: review and cleanup
  const filteredOrderWidgets = orderedWidgets.filter((wc: any) => widgetTypes.includes(wc.type));
  return { widgets: filteredOrderWidgets, order: filteredOrderWidgets.map((wc) => wc.wid) };
};
